import React from 'react';
import type { Redirect as Props } from './redirect.types';

const Redirect: React.FC<Props> = ({ location }) => (
  <div className="redirect">
    <a href={location}>{location}</a>
  </div>
);

export default Redirect;
